import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { DropdownOption, ModalDialogActive } from '@ddv/common-components';
import { ChartConfigItem, LabelValuePair, AGG_TYPES_BY_SECTION_AND_DISPLAY } from '@ddv/models';

@Component({
    selector: 'ddv-column-value-formatting',
    templateUrl: './column-value-formatting.component.html',
    styleUrls: ['../column-formatting-grid/column-formatting-grid.component.scss'],
    providers: [NgModel],
    standalone: false,
})
export class ColumnValueFormattingComponent implements OnInit {
    @Input() parentData: ChartConfigItem | undefined;
    @Input() visualizationType: string | undefined;

    protected readonly modalDialogActive = inject(ModalDialogActive<ChartConfigItem>);
    private readonly fb = inject(FormBuilder);
    private readonly cdr = inject(ChangeDetectorRef);

    protected configForm: FormGroup | undefined;
    protected aggTypes: DropdownOption[] | undefined;

    ngOnInit(): void {
        if (!this.parentData) {
            return console.error('Cannot initialize this component without parentData');
        }

        const chartType = ['PIE_CHART', 'DONUT_CHART'].includes(this.visualizationType ?? '') ? 'circle' : 'chart';
        this.aggTypes = AGG_TYPES_BY_SECTION_AND_DISPLAY[chartType][this.parentData.displayType ?? 'string']
            .map((t: LabelValuePair<string>) => {
                return { text: t.label, key: t.value, value: t.value };
            });

        this.initForm(this.parentData);
        this.toggleCustomNameField();
    }

    protected toggleCustomNameField(): void {
        if (!this.configForm) {
            return;
        }

        if (this.configForm.controls.showCustomName.value) {
            this.configForm.controls.customName.enable();
        } else {
            this.configForm.controls.customName.disable();
        }
    }

    private initForm(data: ChartConfigItem): void {
        this.configForm = this.fb.group(
            {
                customName: [data.customName],
                showCustomName: [data.showCustomName],
                aggregationType: [data.aggregationType],
            },
            {
                validators: (control: AbstractControl) => {
                    const formGroup = control;
                    const showCustomName = formGroup.get('showCustomName');
                    const customName = formGroup.get('customName');

                    if (!showCustomName || !customName) {
                        return null;
                    }

                    if (showCustomName.value) {
                        customName.setValidators(Validators.required);
                    } else {
                        customName.clearValidators();
                    }

                    return null;
                },
            },
        );
        this.cdr.detectChanges();
    }
}
